import { type FunctionComponent, type HTMLAttributes } from 'react';
import { type RequiredNonNullable } from '../../../../../@types/build';
import { type ProductResourceFieldsFragment } from '../../../__generated__/graphql-client-types';
import { CloudinaryImage, type CloudinaryImageProps } from '../../images/cloudinary-image/cloudinary-image.component';
import { ProductTitle } from '../../product-components/product-information/product-information.component';
import { ProductPrice } from '../../product-components/product-price/product-price.component';
import { productOptionActionCard } from './product-option-action-card.css';

export type ProductOptionActionCardProps = {
	image: CloudinaryImageProps;
} & RequiredNonNullable<Pick<ProductResourceFieldsFragment, 'brandName' | 'title' | 'price'>> &
	Pick<HTMLAttributes<HTMLElement>, 'className'>;

export const ProductOptionActionCard: FunctionComponent<ProductOptionActionCardProps> = ({
	className = `${productOptionActionCard} w-100`,
	brandName,
	image,
	title,
	price
}) => (
	<div
		className={`flex flex-column items-center justify-start lh-title ba bg-theme-white b--theme-grey-light br3 f6 hover-b--theme-primary ${className}`}
		data-testid="product-option-action-card">
		<div className="w-100 pa2">
			<CloudinaryImage {...image} className="w-100" options={{ width: 175, height: 175, crop: 'lpad' }} useDimensions={false} />
			<ProductTitle brandName={brandName} title={title} contentClass="tc3-title tl h4" className="flex f5 mt2" />
			<ProductPrice current={price.current} />
		</div>
		<span style={{ height: '1px' }} className="w-100 ma0 bt b--theme-grey-light" />
		<div className="tc pa2 w-100 pointer">
			<span className="theme-primary">Add Item</span>
		</div>
	</div>
);
